import { MessageData } from 'generated/graphql';



export const data: {
  pbv: MessageData;
  marketCap: MessageData;
  dividendYield: MessageData;
  repOfCommonEquity: MessageData;
  operatingMargin: MessageData;
  ebitdaGrowth: MessageData;
  netIncomeGrowth: MessageData;
  accountReceivable: MessageData;
  altmanZScore: MessageData;
  currentRatio: MessageData;
} = {
  netIncomeGrowth: {
    __typename: 'MessageData',
    type: 'glAccount',
    displayName: 'Net Income Growth',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.00',
        period: 'q1',
        year: 2019,
        unit: 'percentage',
        formattedValue: '-0%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.16',
        period: 'q2',
        year: 2019,
        unit: 'percentage',
        formattedValue: '-16%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.13',
        period: 'q3',
        year: 2019,
        unit: 'percentage',
        formattedValue: '-13%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.03',
        period: 'q4',
        year: 2019,
        unit: 'percentage',
        formattedValue: '-3%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.11',
        period: 'q1',
        year: 2020,
        unit: 'percentage',
        formattedValue: '11%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.03',
        period: 'q2',
        year: 2020,
        unit: 'percentage',
        formattedValue: '-3%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.12',
        period: 'q3',
        year: 2020,
        unit: 'percentage',
        formattedValue: '12%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.07',
        period: 'q4',
        year: 2020,
        unit: 'percentage',
        formattedValue: '-7%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.29',
        period: 'q1',
        year: 2021,
        unit: 'percentage',
        formattedValue: '29%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.10',
        period: 'q2',
        year: 2021,
        unit: 'percentage',
        formattedValue: '110%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.93',
        period: 'q3',
        year: 2021,
        unit: 'percentage',
        formattedValue: '93%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.62',
        period: 'q4',
        year: 2021,
        unit: 'percentage',
        formattedValue: '62%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.20',
        period: 'q1',
        year: 2022,
        unit: 'percentage',
        formattedValue: '20%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.06',
        period: 'q2',
        year: 2022,
        unit: 'percentage',
        formattedValue: '6%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.11',
        period: 'q3',
        year: 2022,
        unit: 'percentage',
        formattedValue: '-11%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q4',
        year: 2022,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.13',
        period: 'q1',
        year: 2023,
        unit: 'percentage',
        formattedValue: '-13%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.03',
        period: 'q2',
        year: 2023,
        unit: 'percentage',
        formattedValue: '-3%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.02',
        period: 'q3',
        year: 2023,
        unit: 'percentage',
        formattedValue: '2%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.11',
        period: 'q4',
        year: 2023,
        unit: 'percentage',
        formattedValue: '11%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.13',
        period: 'q1',
        year: 2024,
        unit: 'percentage',
        formattedValue: '13%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.02',
        period: 'q2',
        year: 2024,
        unit: 'percentage',
        formattedValue: '-2%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.08',
        period: 'q3',
        year: 2024,
        unit: 'percentage',
        formattedValue: '8%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.36',
        period: 'q4',
        year: 2024,
        unit: 'percentage',
        formattedValue: '-36%'
      }
    ],
    meta: []
  },
  pbv: {
    __typename: 'MessageData',
    type: null,
    displayName: 'Price to Book Value (P/BV)',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '6.06',
        period: 'q1',
        year: 2019,
        unit: 'multiple',
        formattedValue: '6.06'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '8.11',
        period: 'q2',
        year: 2019,
        unit: 'multiple',
        formattedValue: '8.11'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '9.11',
        period: 'q3',
        year: 2019,
        unit: 'multiple',
        formattedValue: '9.11'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '10.89',
        period: 'q4',
        year: 2019,
        unit: 'multiple',
        formattedValue: '10.89'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '14.01',
        period: 'q1',
        year: 2020,
        unit: 'multiple',
        formattedValue: '14.01'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '13.55',
        period: 'q2',
        year: 2020,
        unit: 'multiple',
        formattedValue: '13.55'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '20.81',
        period: 'q3',
        year: 2020,
        unit: 'multiple',
        formattedValue: '20.81'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '29.47',
        period: 'q4',
        year: 2020,
        unit: 'multiple',
        formattedValue: '29.47'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '33.42',
        period: 'q1',
        year: 2021,
        unit: 'multiple',
        formattedValue: '33.42'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '29.11',
        period: 'q2',
        year: 2021,
        unit: 'multiple',
        formattedValue: '29.11'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '34.17',
        period: 'q3',
        year: 2021,
        unit: 'multiple',
        formattedValue: '34.17'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '38.67',
        period: 'q4',
        year: 2021,
        unit: 'multiple',
        formattedValue: '38.67'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '39.92',
        period: 'q1',
        year: 2022,
        unit: 'multiple',
        formattedValue: '39.92'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '41.99',
        period: 'q2',
        year: 2022,
        unit: 'multiple',
        formattedValue: '41.99'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '39.20',
        period: 'q3',
        year: 2022,
        unit: 'multiple',
        formattedValue: '39.2'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '47.94',
        period: 'q4',
        year: 2022,
        unit: 'multiple',
        formattedValue: '47.94'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '36.25',
        period: 'q1',
        year: 2023,
        unit: 'multiple',
        formattedValue: '36.25'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '41.76',
        period: 'q2',
        year: 2023,
        unit: 'multiple',
        formattedValue: '41.76'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '50.50',
        period: 'q3',
        year: 2023,
        unit: 'multiple',
        formattedValue: '50.5'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '43.34',
        period: 'q4',
        year: 2023,
        unit: 'multiple',
        formattedValue: '43.34'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '40.37',
        period: 'q1',
        year: 2024,
        unit: 'multiple',
        formattedValue: '40.37'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '35.69',
        period: 'q2',
        year: 2024,
        unit: 'multiple',
        formattedValue: '35.69'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '48.46',
        period: 'q3',
        year: 2024,
        unit: 'multiple',
        formattedValue: '48.46'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '61.63',
        period: 'q4',
        year: 2024,
        unit: 'multiple',
        formattedValue: '61.63'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '58.01',
        period: 'q1',
        year: 2025,
        unit: 'multiple',
        formattedValue: '58.01'
      }
    ],
    meta: []
  },
  accountReceivable: {
    __typename: 'MessageData',
    type: 'glAccount',
    displayName: 'Accounts Receivable',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '18077000000.00',
        period: 'q1',
        year: 2019,
        unit: 'usd',
        formattedValue: '$18,077.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '15085000000.00',
        period: 'q2',
        year: 2019,
        unit: 'usd',
        formattedValue: '$15,085.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '14148000000.00',
        period: 'q3',
        year: 2019,
        unit: 'usd',
        formattedValue: '$14,148.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '22926000000.00',
        period: 'q4',
        year: 2019,
        unit: 'usd',
        formattedValue: '$22,926.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '20970000000.00',
        period: 'q1',
        year: 2020,
        unit: 'usd',
        formattedValue: '$20,970.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '15722000000.00',
        period: 'q2',
        year: 2020,
        unit: 'usd',
        formattedValue: '$15,722.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '17882000000.00',
        period: 'q3',
        year: 2020,
        unit: 'usd',
        formattedValue: '$17,882.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '16120000000.00',
        period: 'q4',
        year: 2020,
        unit: 'usd',
        formattedValue: '$16,120.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '27101000000.00',
        period: 'q1',
        year: 2021,
        unit: 'usd',
        formattedValue: '$27,101.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '18503000000.00',
        period: 'q2',
        year: 2021,
        unit: 'usd',
        formattedValue: '$18,503.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '17475000000.00',
        period: 'q3',
        year: 2021,
        unit: 'usd',
        formattedValue: '$17,475.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '26278000000.00',
        period: 'q4',
        year: 2021,
        unit: 'usd',
        formattedValue: '$26,278.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '30213000000.00',
        period: 'q1',
        year: 2022,
        unit: 'usd',
        formattedValue: '$30,213.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '20815000000.00',
        period: 'q2',
        year: 2022,
        unit: 'usd',
        formattedValue: '$20,815.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '21803000000.00',
        period: 'q3',
        year: 2022,
        unit: 'usd',
        formattedValue: '$21,803.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '28184000000.00',
        period: 'q4',
        year: 2022,
        unit: 'usd',
        formattedValue: '$28,184.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '23752000000.00',
        period: 'q1',
        year: 2023,
        unit: 'usd',
        formattedValue: '$23,752.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '17936000000.00',
        period: 'q2',
        year: 2023,
        unit: 'usd',
        formattedValue: '$17,936.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '19549000000.00',
        period: 'q3',
        year: 2023,
        unit: 'usd',
        formattedValue: '$19,549.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '29508000000.00',
        period: 'q4',
        year: 2023,
        unit: 'usd',
        formattedValue: '$29,508.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '23194000000.00',
        period: 'q1',
        year: 2024,
        unit: 'usd',
        formattedValue: '$23,194.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '21837000000.00',
        period: 'q2',
        year: 2024,
        unit: 'usd',
        formattedValue: '$21,837.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '22795000000.00',
        period: 'q3',
        year: 2024,
        unit: 'usd',
        formattedValue: '$22,795.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '33410000000.00',
        period: 'q4',
        year: 2024,
        unit: 'usd',
        formattedValue: '$33,410.00M'
      }
    ],
    meta: []
  },
  marketCap: {
    __typename: 'MessageData',
    type: 'glAccount',
    displayName: 'Market Capitalization',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '713874660907.90',
        period: 'q1',
        year: 2019,
        unit: 'usd',
        formattedValue: '$713,874.66M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '858417654870.20',
        period: 'q2',
        year: 2019,
        unit: 'usd',
        formattedValue: '$858,417.65M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '878918932766.60',
        period: 'q3',
        year: 2019,
        unit: 'usd',
        formattedValue: '$878,918.93M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '985499501058.00',
        period: 'q4',
        year: 2019,
        unit: 'usd',
        formattedValue: '$985,499.50M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1254375131281.10',
        period: 'q1',
        year: 2020,
        unit: 'usd',
        formattedValue: '$1,254,375.13M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1062823210655.50',
        period: 'q2',
        year: 2020,
        unit: 'usd',
        formattedValue: '$1,062,823.21M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1503971599936.60',
        period: 'q3',
        year: 2020,
        unit: 'usd',
        formattedValue: '$1,503,971.60M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1925510434898.30',
        period: 'q4',
        year: 2020,
        unit: 'usd',
        formattedValue: '$1,925,510.43M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2213467965541.70',
        period: 'q1',
        year: 2021,
        unit: 'usd',
        formattedValue: '$2,213,467.97M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2014079888344.40',
        period: 'q2',
        year: 2021,
        unit: 'usd',
        formattedValue: '$2,014,079.89M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2196279002455.40',
        period: 'q3',
        year: 2021,
        unit: 'usd',
        formattedValue: '$2,196,279.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2439806214683.00',
        period: 'q4',
        year: 2021,
        unit: 'usd',
        formattedValue: '$2,439,806.21M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2871560533099.90',
        period: 'q1',
        year: 2022,
        unit: 'usd',
        formattedValue: '$2,871,560.53M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2829767504958.80',
        period: 'q2',
        year: 2022,
        unit: 'usd',
        formattedValue: '$2,829,767.50M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2277931856602.70',
        period: 'q3',
        year: 2022,
        unit: 'usd',
        formattedValue: '$2,277,931.86M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2428965146311.40',
        period: 'q4',
        year: 2022,
        unit: 'usd',
        formattedValue: '$2,428,965.15M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2056186862228.00',
        period: 'q1',
        year: 2023,
        unit: 'usd',
        formattedValue: '$2,056,186.86M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2595783431631.90',
        period: 'q2',
        year: 2023,
        unit: 'usd',
        formattedValue: '$2,595,783.43M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '3043716407495.20',
        period: 'q3',
        year: 2023,
        unit: 'usd',
        formattedValue: '$3,043,716.41M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2693483955904.80',
        period: 'q4',
        year: 2023,
        unit: 'usd',
        formattedValue: '$2,693,483.96M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2991091784578.90',
        period: 'q1',
        year: 2024,
        unit: 'usd',
        formattedValue: '$2,991,091.78M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2648296316618.60',
        period: 'q2',
        year: 2024,
        unit: 'usd',
        formattedValue: '$2,648,296.32M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '3232632618500.00',
        period: 'q3',
        year: 2024,
        unit: 'usd',
        formattedValue: '$3,232,632.62M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '3509809960050.00',
        period: 'q4',
        year: 2024,
        unit: 'usd',
        formattedValue: '$3,509,809.96M'
      }
    ],
    meta: []
  },
  repOfCommonEquity: {
    __typename: 'MessageData',
    type: null,
    displayName: 'Repurchase of Common Equity',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-8796000000.00',
        period: 'q1',
        year: 2019,
        unit: 'usd',
        formattedValue: '-$8,796.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-23702000000.00',
        period: 'q2',
        year: 2019,
        unit: 'usd',
        formattedValue: '-$23,702.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-16955000000.00',
        period: 'q3',
        year: 2019,
        unit: 'usd',
        formattedValue: '-$16,955.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-17444000000.00',
        period: 'q4',
        year: 2019,
        unit: 'usd',
        formattedValue: '-$17,444.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-20706000000.00',
        period: 'q1',
        year: 2020,
        unit: 'usd',
        formattedValue: '-$20,706.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-18574000000.00',
        period: 'q2',
        year: 2020,
        unit: 'usd',
        formattedValue: '-$18,574.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-15891000000.00',
        period: 'q3',
        year: 2020,
        unit: 'usd',
        formattedValue: '-$15,891.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-17187000000.00',
        period: 'q4',
        year: 2020,
        unit: 'usd',
        formattedValue: '-$17,187.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-24775000000.00',
        period: 'q1',
        year: 2021,
        unit: 'usd',
        formattedValue: '-$24,775.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-18548000000.00',
        period: 'q2',
        year: 2021,
        unit: 'usd',
        formattedValue: '-$18,548.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-22900000000.00',
        period: 'q3',
        year: 2021,
        unit: 'usd',
        formattedValue: '-$22,900.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-19748000000.00',
        period: 'q4',
        year: 2021,
        unit: 'usd',
        formattedValue: '-$19,748.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-20478000000.00',
        period: 'q1',
        year: 2022,
        unit: 'usd',
        formattedValue: '-$20,478.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-22631000000.00',
        period: 'q2',
        year: 2022,
        unit: 'usd',
        formattedValue: '-$22,631.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-21865000000.00',
        period: 'q3',
        year: 2022,
        unit: 'usd',
        formattedValue: '-$21,865.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-24428000000.00',
        period: 'q4',
        year: 2022,
        unit: 'usd',
        formattedValue: '-$24,428.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-19475000000.00',
        period: 'q1',
        year: 2023,
        unit: 'usd',
        formattedValue: '-$19,475.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-19594000000.00',
        period: 'q2',
        year: 2023,
        unit: 'usd',
        formattedValue: '-$19,594.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-17478000000.00',
        period: 'q3',
        year: 2023,
        unit: 'usd',
        formattedValue: '-$17,478.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-21003000000.00',
        period: 'q4',
        year: 2023,
        unit: 'usd',
        formattedValue: '-$21,003.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-20139000000.00',
        period: 'q1',
        year: 2024,
        unit: 'usd',
        formattedValue: '-$20,139.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-23205000000.00',
        period: 'q2',
        year: 2024,
        unit: 'usd',
        formattedValue: '-$23,205.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-26522000000.00',
        period: 'q3',
        year: 2024,
        unit: 'usd',
        formattedValue: '-$26,522.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-25083000000.00',
        period: 'q4',
        year: 2024,
        unit: 'usd',
        formattedValue: '-$25,083.00M'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-23606000000.00',
        period: 'q1',
        year: 2025,
        unit: 'usd',
        formattedValue: '-$23,606.00M'
      }
    ],
    meta: []
  },
  dividendYield: {
    __typename: 'MessageData',
    type: null,
    displayName: 'Dividend Yield',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.02',
        period: 'q1',
        year: 2019,
        unit: 'percentage',
        formattedValue: '2%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.02',
        period: 'q2',
        year: 2019,
        unit: 'percentage',
        formattedValue: '2%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.02',
        period: 'q3',
        year: 2019,
        unit: 'percentage',
        formattedValue: '2%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q4',
        year: 2019,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q1',
        year: 2020,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q2',
        year: 2020,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q3',
        year: 2020,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.00',
        period: 'q4',
        year: 2020,
        unit: 'percentage',
        formattedValue: '0%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q1',
        year: 2021,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q2',
        year: 2021,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q3',
        year: 2021,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q4',
        year: 2021,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.00',
        period: 'q1',
        year: 2022,
        unit: 'percentage',
        formattedValue: '0%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q2',
        year: 2022,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q3',
        year: 2022,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q4',
        year: 2022,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q1',
        year: 2023,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q2',
        year: 2023,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.00',
        period: 'q3',
        year: 2023,
        unit: 'percentage',
        formattedValue: '0%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q4',
        year: 2023,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.00',
        period: 'q1',
        year: 2024,
        unit: 'percentage',
        formattedValue: '0%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q2',
        year: 2024,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.00',
        period: 'q3',
        year: 2024,
        unit: 'percentage',
        formattedValue: '0%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.00',
        period: 'q4',
        year: 2024,
        unit: 'percentage',
        formattedValue: '0%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.00',
        period: 'q1',
        year: 2025,
        unit: 'percentage',
        formattedValue: '0%'
      }
    ],
    meta: []
  },
  ebitdaGrowth: {
    __typename: 'MessageData',
    type: null,
    displayName: 'EBITDA Growth',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.08',
        period: 'q1',
        year: 2019,
        unit: 'percentage',
        formattedValue: '-8%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.11',
        period: 'q2',
        year: 2019,
        unit: 'percentage',
        formattedValue: '-11%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.07',
        period: 'q3',
        year: 2019,
        unit: 'percentage',
        formattedValue: '-7%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.01',
        period: 'q4',
        year: 2019,
        unit: 'percentage',
        formattedValue: '1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.05',
        period: 'q1',
        year: 2020,
        unit: 'percentage',
        formattedValue: '5%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.05',
        period: 'q2',
        year: 2020,
        unit: 'percentage',
        formattedValue: '-5%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.07',
        period: 'q3',
        year: 2020,
        unit: 'percentage',
        formattedValue: '7%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.09',
        period: 'q4',
        year: 2020,
        unit: 'percentage',
        formattedValue: '-9%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.26',
        period: 'q1',
        year: 2021,
        unit: 'percentage',
        formattedValue: '26%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.94',
        period: 'q2',
        year: 2021,
        unit: 'percentage',
        formattedValue: '94%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.71',
        period: 'q3',
        year: 2021,
        unit: 'percentage',
        formattedValue: '71%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.49',
        period: 'q4',
        year: 2021,
        unit: 'percentage',
        formattedValue: '49%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.21',
        period: 'q1',
        year: 2022,
        unit: 'percentage',
        formattedValue: '21%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.07',
        period: 'q2',
        year: 2022,
        unit: 'percentage',
        formattedValue: '7%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.05',
        period: 'q3',
        year: 2022,
        unit: 'percentage',
        formattedValue: '-5%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.05',
        period: 'q4',
        year: 2022,
        unit: 'percentage',
        formattedValue: '5%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.12',
        period: 'q1',
        year: 2023,
        unit: 'percentage',
        formattedValue: '-12%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.05',
        period: 'q2',
        year: 2023,
        unit: 'percentage',
        formattedValue: '-5%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.00',
        period: 'q3',
        year: 2023,
        unit: 'percentage',
        formattedValue: '-0%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.08',
        period: 'q4',
        year: 2023,
        unit: 'percentage',
        formattedValue: '8%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.12',
        period: 'q1',
        year: 2024,
        unit: 'percentage',
        formattedValue: '12%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '-0.01',
        period: 'q2',
        year: 2024,
        unit: 'percentage',
        formattedValue: '-1%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.10',
        period: 'q3',
        year: 2024,
        unit: 'percentage',
        formattedValue: '10%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.10',
        period: 'q4',
        year: 2024,
        unit: 'percentage',
        formattedValue: '10%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.06',
        period: 'q1',
        year: 2025,
        unit: 'percentage',
        formattedValue: '6%'
      }
    ],
    meta: []
  },
  operatingMargin: {
    __typename: 'MessageData',
    type: null,
    displayName: 'Operating Margin',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.28',
        period: 'q1',
        year: 2019,
        unit: 'percentage',
        formattedValue: '28%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.23',
        period: 'q2',
        year: 2019,
        unit: 'percentage',
        formattedValue: '23%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.21',
        period: 'q3',
        year: 2019,
        unit: 'percentage',
        formattedValue: '21%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.24',
        period: 'q4',
        year: 2019,
        unit: 'percentage',
        formattedValue: '24%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.28',
        period: 'q1',
        year: 2020,
        unit: 'percentage',
        formattedValue: '28%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.22',
        period: 'q2',
        year: 2020,
        unit: 'percentage',
        formattedValue: '22%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.22',
        period: 'q3',
        year: 2020,
        unit: 'percentage',
        formattedValue: '22%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.23',
        period: 'q4',
        year: 2020,
        unit: 'percentage',
        formattedValue: '23%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.30',
        period: 'q1',
        year: 2021,
        unit: 'percentage',
        formattedValue: '30%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.31',
        period: 'q2',
        year: 2021,
        unit: 'percentage',
        formattedValue: '31%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.30',
        period: 'q3',
        year: 2021,
        unit: 'percentage',
        formattedValue: '30%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.29',
        period: 'q4',
        year: 2021,
        unit: 'percentage',
        formattedValue: '29%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.33',
        period: 'q1',
        year: 2022,
        unit: 'percentage',
        formattedValue: '33%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.31',
        period: 'q2',
        year: 2022,
        unit: 'percentage',
        formattedValue: '31%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.28',
        period: 'q3',
        year: 2022,
        unit: 'percentage',
        formattedValue: '28%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.28',
        period: 'q4',
        year: 2022,
        unit: 'percentage',
        formattedValue: '28%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.31',
        period: 'q1',
        year: 2023,
        unit: 'percentage',
        formattedValue: '31%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.30',
        period: 'q2',
        year: 2023,
        unit: 'percentage',
        formattedValue: '30%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.28',
        period: 'q3',
        year: 2023,
        unit: 'percentage',
        formattedValue: '28%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.30',
        period: 'q4',
        year: 2023,
        unit: 'percentage',
        formattedValue: '30%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.34',
        period: 'q1',
        year: 2024,
        unit: 'percentage',
        formattedValue: '34%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.31',
        period: 'q2',
        year: 2024,
        unit: 'percentage',
        formattedValue: '31%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.30',
        period: 'q3',
        year: 2024,
        unit: 'percentage',
        formattedValue: '30%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.31',
        period: 'q4',
        year: 2024,
        unit: 'percentage',
        formattedValue: '31%'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.34',
        period: 'q1',
        year: 2025,
        unit: 'percentage',
        formattedValue: '34%'
      }
    ],
    meta: []
  },
  altmanZScore: {
    __typename: 'MessageData',
    type: 'glAccount',
    displayName: 'Altman Z-Score',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '2.99',
        period: 'q1',
        year: 2019,
        unit: 'float',
        formattedValue: '2.99'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '3.44',
        period: 'q2',
        year: 2019,
        unit: 'float',
        formattedValue: '3.44'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '3.66',
        period: 'q3',
        year: 2019,
        unit: 'float',
        formattedValue: '3.66'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '3.70',
        period: 'q4',
        year: 2019,
        unit: 'float',
        formattedValue: '3.7'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '4.43',
        period: 'q1',
        year: 2020,
        unit: 'float',
        formattedValue: '4.43'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '3.93',
        period: 'q2',
        year: 2020,
        unit: 'float',
        formattedValue: '3.93'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '4.96',
        period: 'q3',
        year: 2020,
        unit: 'float',
        formattedValue: '4.96'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '5.67',
        period: 'q4',
        year: 2020,
        unit: 'float',
        formattedValue: '5.67'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '5.89',
        period: 'q1',
        year: 2021,
        unit: 'float',
        formattedValue: '5.89'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '5.87',
        period: 'q2',
        year: 2021,
        unit: 'float',
        formattedValue: '5.87'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '6.32',
        period: 'q3',
        year: 2021,
        unit: 'float',
        formattedValue: '6.32'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '6.40',
        period: 'q4',
        year: 2021,
        unit: 'float',
        formattedValue: '6.4'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '6.99',
        period: 'q1',
        year: 2022,
        unit: 'float',
        formattedValue: '6.99'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '7.40',
        period: 'q2',
        year: 2022,
        unit: 'float',
        formattedValue: '7.4'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '6.25',
        period: 'q3',
        year: 2022,
        unit: 'float',
        formattedValue: '6.25'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '6.10',
        period: 'q4',
        year: 2022,
        unit: 'float',
        formattedValue: '6.1'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '5.69',
        period: 'q1',
        year: 2023,
        unit: 'float',
        formattedValue: '5.69'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '7.20',
        period: 'q2',
        year: 2023,
        unit: 'float',
        formattedValue: '7.2'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '8.01',
        period: 'q3',
        year: 2023,
        unit: 'float',
        formattedValue: '8.01'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '6.90',
        period: 'q4',
        year: 2023,
        unit: 'float',
        formattedValue: '6.9'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '7.96',
        period: 'q1',
        year: 2024,
        unit: 'float',
        formattedValue: '7.96'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '7.48',
        period: 'q2',
        year: 2024,
        unit: 'float',
        formattedValue: '7.48'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '8.70',
        period: 'q3',
        year: 2024,
        unit: 'float',
        formattedValue: '8.7'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '8.03',
        period: 'q4',
        year: 2024,
        unit: 'float',
        formattedValue: '8.03'
      }
    ],
    meta: []
  },
  currentRatio: {
    __typename: 'MessageData',
    type: 'glAccount',
    displayName: 'Current Ratio',
    values: [
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.30',
        period: 'q1',
        year: 2019,
        unit: 'float',
        formattedValue: '1.3'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.32',
        period: 'q2',
        year: 2019,
        unit: 'float',
        formattedValue: '1.32'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.50',
        period: 'q3',
        year: 2019,
        unit: 'float',
        formattedValue: '1.5'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.54',
        period: 'q4',
        year: 2019,
        unit: 'float',
        formattedValue: '1.54'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.60',
        period: 'q1',
        year: 2020,
        unit: 'float',
        formattedValue: '1.6'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.50',
        period: 'q2',
        year: 2020,
        unit: 'float',
        formattedValue: '1.5'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.47',
        period: 'q3',
        year: 2020,
        unit: 'float',
        formattedValue: '1.47'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.36',
        period: 'q4',
        year: 2020,
        unit: 'float',
        formattedValue: '1.36'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.16',
        period: 'q1',
        year: 2021,
        unit: 'float',
        formattedValue: '1.16'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.14',
        period: 'q2',
        year: 2021,
        unit: 'float',
        formattedValue: '1.14'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.06',
        period: 'q3',
        year: 2021,
        unit: 'float',
        formattedValue: '1.06'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.07',
        period: 'q4',
        year: 2021,
        unit: 'float',
        formattedValue: '1.07'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.04',
        period: 'q1',
        year: 2022,
        unit: 'float',
        formattedValue: '1.04'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.93',
        period: 'q2',
        year: 2022,
        unit: 'float',
        formattedValue: '0.93'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.86',
        period: 'q3',
        year: 2022,
        unit: 'float',
        formattedValue: '0.86'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.88',
        period: 'q4',
        year: 2022,
        unit: 'float',
        formattedValue: '0.88'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.94',
        period: 'q1',
        year: 2023,
        unit: 'float',
        formattedValue: '0.94'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.94',
        period: 'q2',
        year: 2023,
        unit: 'float',
        formattedValue: '0.94'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.98',
        period: 'q3',
        year: 2023,
        unit: 'float',
        formattedValue: '0.98'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.99',
        period: 'q4',
        year: 2023,
        unit: 'float',
        formattedValue: '0.99'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.07',
        period: 'q1',
        year: 2024,
        unit: 'float',
        formattedValue: '1.07'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '1.04',
        period: 'q2',
        year: 2024,
        unit: 'float',
        formattedValue: '1.04'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.95',
        period: 'q3',
        year: 2024,
        unit: 'float',
        formattedValue: '0.95'
      },
      {
        __typename: 'MessageDataValue',
        label: '',
        value: '0.87',
        period: 'q4',
        year: 2024,
        unit: 'float',
        formattedValue: '0.87'
      }
    ],
    meta: []
  }
};
